/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum LoyaltyRuleActionTypeApiModel {
  DiscountPercentByItem = 'discount-percent-by-item',

  DiscountAmountByItem = 'discount-amount-by-item',

  SpecialPriceByItem = 'special-price-by-item',

  DiscountPercentByCheck = 'discount-percent-by-check',

  DiscountAmountByCheck = 'discount-amount-by-check',

  ChargePercentByItem = 'charge-percent-by-item',

  ChargeAmountByItem = 'charge-amount-by-item',

  ChargePercentByCheck = 'charge-percent-by-check',

  ChargeAmountByCheck = 'charge-amount-by-check',

  EmissionCouponByItem = 'emission-coupon-by-item',

  EmissionCouponByCheck = 'emission-coupon-by-check'
}
